// Vendors
import React from 'react';
import classnames from 'classnames';

const Modal = ({
  children,
  title,
  description,
  modalID,
  toggleModal,
  size,
  ...props
}) => {
  const modalClasses = {
    'modal--resource': true,
    'modal--valign-center': true,
    'modal--visible': modalID
  };

  const handleClickClose = status => toggleModal(status);

  return (
    <div className={classnames('modal', modalClasses, size)} tabIndex="-1">
      <div className="modal__dialog">
        <div className="modal__content">
          <span
            className="modal__close"
            onClick={() => handleClickClose(false)}
          />
          <header className="modal__header">
            <h2 className="modal__title">{title}</h2>
          </header>
          {children ? (
            children
          ) : (
            <>
              <section className="modal__body">
                <div
                  className="u--squash"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </section>
              <footer className="modal__footer u--text-align-right">
                <span className="btn" onClick={() => handleClickClose(false)}>
                  Close
                </span>
              </footer>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
